import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const revealCouponHandler: ActionHandler = {
  type: 'reveal_coupon',
  execute(ctx) {
    const config = ctx.config;
    const port = ctx.semanticPorts?.revealCoupon;
    return invokeSemanticPort(
      ctx,
      'reveal_coupon',
      port
        ? (context) =>
            port(
              {
                couponCode: readString(config, 'couponCode', 'coupon_code'),
                targetBlockId:
                  readString(config, 'targetBlockId', 'target_block_id') ??
                  ctx.intentEnvelope?.payload.context.blockId,
              },
              context
            )
        : undefined
    );
  },
};
